import * as React from 'react';
import {
  ProContentWrapper, FormWrapper, TextWrapper, BaselinePro, EspaceProAsideWrapper, EspaceProAsideElement,
  EspaceProCardIconWrapper, EspaceProAsideSection
} from './ProContent.s';
import { Paragraph, EspaceProSmallHeading, SmallCardParagraph } from '@components/Typos/Typos.s';
import { ProForm } from '@components/ProForm/ProForm';
import { Accord, Graphique, Tirelire } from '@components/Icons';

export const ProContent = () => {
  return (
    <div>
      <ProContentWrapper>
        <FormWrapper>
          <ProForm />
        </FormWrapper>
        <TextWrapper>
          <BaselinePro>
            Envie de promouvoir votre exposition ?<br />
            <b>On a ce qu’il vous faut.</b>
          </BaselinePro>
          <Paragraph>
            Démarrez en toute simplicité avec Start ! <br />
            Que vous soyez particulier ou professionel,
          proposez nous dès maintenant votre exposition et nous allons l’inclure dans notre application.
        </Paragraph>
        </TextWrapper>
      </ProContentWrapper>
      <EspaceProAsideWrapper>
        <EspaceProAsideSection>
          <EspaceProAsideElement>
            <EspaceProCardIconWrapper><Tirelire /></EspaceProCardIconWrapper>
            <EspaceProSmallHeading>Notre service est gratuit*</EspaceProSmallHeading>
            <SmallCardParagraph>
              Pour les trois premières expositions recensées.
                Au bout de la quatrième, nous vous proposeront un partenariat si vous êtes
                satisfaits de nos services.
              </SmallCardParagraph>
          </EspaceProAsideElement>

          <EspaceProAsideElement>
            <EspaceProCardIconWrapper><Graphique /></EspaceProCardIconWrapper>
            <EspaceProSmallHeading>Touchez un public aguéri</EspaceProSmallHeading>
            <SmallCardParagraph>
              Mettre vos évènements culturels sur Start, c’est s’assurer d’un public
                dynamique et intéressé par ce que vous faites.
              </SmallCardParagraph>
          </EspaceProAsideElement>

          <EspaceProAsideElement>
            <EspaceProCardIconWrapper><Accord /></EspaceProCardIconWrapper>
            <EspaceProSmallHeading>On est là pour vous aider</EspaceProSmallHeading>
            <SmallCardParagraph>
              Nous vous accompagnons pour gérer la mise en ligne de vos expositions
                sur Start du début à la fin. Alors, prêt à vous lancer ?
              </SmallCardParagraph>
          </EspaceProAsideElement>
        </EspaceProAsideSection>
      </EspaceProAsideWrapper>
    </div>
  );
};



// WEBPACK FOOTER //
// src/app/src/components/ProContent/ProContent.tsx